import styled from "@emotion/styled";
import { get } from "lodash";

const Styled = styled.div`
  width: 100%;
  & > div,
  .react-datepicker {
    display: flex;
    border: none;
    width: 100%;
  }
  .react-datepicker__month-container {
    flex: 1;
  }
  .header-text {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    margin: 10px;
  }
  .header-arrow {
    width: 40px;
    height: 40px;
    background: #dddbea70;
    border-radius: 8px;
    cursor: pointer;
    &.disabled {
      opacity: 0.5;
      cursor: unset;
    }
    img {
      width: 20px;
    }
  }
  .react-datepicker__header {
    background: none;
    border: none;
  }
  .react-datepicker__month {
    margin-top: 0;
    margin: 0;
  }

  .react-datepicker__day-names,
  .react-datepicker__week {
    display: flex;
  }
  .react-datepicker__day-name {
    &:nth-of-type(6) {
      color: red;
    }
    &:nth-of-type(7) {
      color: red;
    }
  }
  .react-datepicker__day,
  .react-datepicker__day-name {
    margin: 0;
    flex: 1;
    width: auto !important;
    height: 65px;
    padding: 8px 12px;
    text-align: start;
    border-radius: 0;
    display: flex;
    flex-direction: column;

    .day {
      font-size: 18px;
      color: #2d2d4b;
      font-weight: 500;
      &.noplace {
        color: #c0c0c8;
        text-decoration: line-through;
      }
    }
    .price {
      color: #65646c;
      max-width: 36px;
      font-size: 12px;

      &.noplace {
        display: none;
      }

      span {
        color: #acacac;
      }
    }

    &--disabled {
      .price {
        display: none;
      }
      .day {
        color: #c0c0c8;
        /* text-decoration: line-through; */
      }
    }

    &--in-range,
    &--in-selecting-range {
      background: ${(props) => get(props, "design.colors.primary", "#ffc329") + "20"} !important;
    }

    &--keyboard-selected {
      background: transparent;
      &:hover {
        background: transparent;
      }
    }

    &--range-end {
      background: ${(props) => get(props, "design.colors.primary", "#ffc329") + "70"} !important;
      border-radius: 0px 16px 16px 0px;

      &.react-datepicker__day--outside-month {
        border-radius: 0;
        background: ${(props) => get(props, "design.colors.primary", "#ffc329") + "70"} !important;
      }
    }

    &--range-start,
    &--selected {
      border-radius: 15px 0px 0px 16px;
      background: ${(props) => get(props, "design.colors.primary", "#ffc329") + "70"} !important;

      &.react-datepicker__day--outside-month {
        border-radius: 0;
        background: ${(props) => get(props, "design.colors.primary", "#ffc329") + "70"} !important;
      }
    }

    &--outside-month {
      .day {
        color: #c0c0c8;
      }
      .price {
        display: none;
      }
    }
  }
  .react-datepicker__day-name {
    height: 40px;
  }

  @media (max-width: 720px) {
    .react-datepicker__day {
      height: 70px;
      padding: 6px;
    }
    .react-datepicker__day-name {
      padding: 6px;
    }
  }

  @media (max-width: 530px) {
    .react-datepicker__day,
    .react-datepicker__day-name {
      height: 55px !important;
    }

    .header-arrow {
      height: 30px;
      width: 30px;
      img {
        width: 18px;
      }
    }
    .price {
      font-size: 8px !important;
    }
    .day {
      line-height: 1;
      font-size: 16px !important;
    }
  }

  @media (max-width: 420px) {
    .react-datepicker__day,
    .react-datepicker__day-name {
      height: 50px !important;
    }
    .day {
      font-size: 14px !important;
    }
  }
`;

export default Styled;
